(function () {
    // TODO: this is same as friend invite screen. Create a dumb component

    angular.module('tradersyard').component('tyInvitationsScreenInviteParticipants', {
        bindings: {
            entryType: '@',
            entryId: '@',
            parentEntries: '<',
        },
        controller: InvitationsScreenInviteParticipantsCtrl,
        // language=HTML
        template: `
            <div class="invitation-screen-invite-participants">
                <input ng-model="$ctrl.searchQuery"
                       ng-model-options="{debounce: 200}"
                       ng-change="$ctrl.onSearchQueryChange($ctrl.searchQuery)"
                       class="form-control input-lg" type="search" placeholder="Type here to search for people...">

                <h2 ng-show="$ctrl.isLoading" class="text-center">
                    <span class="fa fa-spin fa-spinner"></span> Loading...
                </h2>
                <h3 ng-show="!$ctrl.isLoading && !$ctrl.people.length" class="text-center text-muted">
                    No search results
                </h3>
                <ty-invitations-people-list
                        people="$ctrl.people"
                        on-invite="$ctrl.onInvite(person)"
                        ng-hide="$ctrl.isLoading">
                </ty-invitations-people-list>
            </div>
        `,
    });

    InvitationsScreenInviteParticipantsCtrl.$inject = ['graph-search-factory', 'graph-invite-factory'];

    /**
     * @property {string[]} parentEntries
     * @param searchApiFactory
     * @param inviteApiFactory
     * @constructor
     */
    function InvitationsScreenInviteParticipantsCtrl(searchApiFactory, inviteApiFactory) {
        const ctrl = this;

        const DEFAULT_SEARCH_PARAMS = {
            page: 1,
            limit: 25,
        };

        let searchApi; // graph-search-factory.place
        let inviteApi; // graph-invite-factory.entry

        /**
         * Indicates that some API request is in progress.
         * Starts with loading state - avoid showing "no results" message.
         * @type {boolean}
         */
        ctrl.isLoading = true;

        /**
         * @type {string|undefined}
         */
        ctrl.searchQuery = undefined;

        /**
         * List of people objects.
         * @type {object[]}
         */
        ctrl.people = [];

        ctrl.$onInit = $onInit;
        ctrl.$onChanges = $onChanges;

        ctrl.onInvite = onInvite;
        ctrl.onSearchQueryChange = onSearchQueryChange;

        function onInvite(person) {
            return _invitePerson(person).then(() => (person.is_invited = true));
        }

        function $onInit() {
            $onChanges({});
        }

        /**
         * @param {angular.IOnChangesObject} changes
         */
        function $onChanges(changes) {
            // emit new values of parentEntries
            const parentEntries = changes?.parentEntries?.currentValue;

            if (!parentEntries) {
                return;
            }

            // create API services
            searchApi = searchApiFactory.place(ctrl.entryType, ctrl.entryId);
            inviteApi = inviteApiFactory.entry(ctrl.entryType, ctrl.entryId);
            onSearchQueryChange();
        }

        function onSearchQueryChange(newQueryValue) {
            ctrl.isLoading = true;
            _getParticipants(newQueryValue)
                .then((data) => (ctrl.people = data))
                .finally(() => (ctrl.isLoading = false));
        }

        function _getParticipants(query) {
            const place = ctrl.parentEntries.length ? ctrl.parentEntries.join(',') : undefined;
            const params = { ...DEFAULT_SEARCH_PARAMS, place, q: query };

            return searchApi.search('participant', { params }).then(function (response) {
                return response.data.state === 0 ? response.data.data ?? [] : Promise.reject([]);
            });
        }

        function _invitePerson(person) {
            return inviteApi.create(person.id, {}).then(function (response) {
                return response.data.state === 0 ? response.data.data : Promise.reject();
            });
        }
    }
})();
